import templateUrl from 'emun.salesrep/salesrep-top-commitments.htm';
import basicController from "servicestack/basic.controller.properties";

class SalesRepTopCommitmentsController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this;
		basicController($ctrl);
		$ctrl.utils = utils;
		var context = $ctrl.context || 'rep';
		var queryCriteria = '';

		var filter = "RepId";
		if (context == 'executive') {
			filter = '';
		} else if (context === 'manager') {
			filter = 'ManagerId' + '=' + $ctrl.rep.id;
		} else {
			filter = filter + '=' + $ctrl.rep.id;
		}
		//console.info('date r: ' + $ctrl.dateRange + ' : title: ' + $ctrl.title);
		var dateRange = $ctrl.dateRange || "Last12Months";
		this.topCustomers = createAutoQuery({
			url: 'QueryCartItemsJoin?CartStatus=Commitment&Sum=CartItemExtendedTotal&GroupBy=RetailerId,CompanyName,CartGrandTotal&OrderByDesc=CartGrandTotal&' + filter,
			autoLoad: true,
			pageSize: 10
		});
	}
	//downloadData() {
	//	let $ctrl = this;
	//	var url = $ctrl.$appConfig.serviceUrl + "" + $ctrl.topCustomers.url.replace(".json", ".csv");
	//	return location.href = url;
	//}
	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			name: 'Name',
			amount: "Amount",
		};

		// format the data
		$ctrl.topCustomers.results.forEach((item) => {
			itemsFormatted.push({
				name: item.companyName.replace(/,/g, ''), // remove commas to avoid errors,
				amount: item.sumCartItemExtendedTotal,
			});
		});

		var fileTitle = 'salesrep-top-commitments';
		$ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'amount').reverse(), fileTitle);
	}
}

let SalesRepTopCommitments = {
	bindings: {
		rep: '<',
		repGroup: '@',
		context: '@',
		dateRange: '@',
		title: '@',
		insideSales: '@',
		onlyKeyAccounts: '@'
	},
	controller: SalesRepTopCommitmentsController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}


export default SalesRepTopCommitments;